import { render, staticRenderFns } from "./qrCode.vue?vue&type=template&id=2b4d994e&scoped=true"
import script from "./qrCode.vue?vue&type=script&lang=ts"
export * from "./qrCode.vue?vue&type=script&lang=ts"
import style0 from "./qrCode.vue?vue&type=style&index=0&id=2b4d994e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4d994e",
  null
  
)

export default component.exports